import { Button, Popconfirm } from "antd";
import React, { ReactElement, useCallback, useEffect, useState } from "react";
import { authenticateToken } from "../../../utils/auth";
import Loading from "../../common/Loader";
import axios from "axios";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import moment from "moment";

const OrderPaymentLogs = ({ orderDetails }: any): ReactElement => {
  const [loading, setLoading] = useState(false);
  const [paymentLogs, setPaymentLogs] = useState({
    loading: false,
    data: null,
  });

  const getPaymentLogs = useCallback(async () => {
    setPaymentLogs({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_PAY_API}`;
    axios
      .get(
        `${encodedUri}/admin/payment/transactions?baseOrderId=${orderDetails?.baseOrderId}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setPaymentLogs({ loading: false, data: res.data });
      })
      .catch((err) => {
        setPaymentLogs({ loading: false, data: [] });
        console.error("Payments: Error", err);
      });
  }, []);

  const onPaymentStatus = async (data) => {
    setLoading(true);

    await fetch(`${process.env.REACT_APP_PAY_API}/bkash/manual/success`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification(
            "Payment Status Updated Successfully",
            "success"
          );
          getPaymentLogs();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  useEffect(() => {
    getPaymentLogs();
  }, [getPaymentLogs]);

  return (
    <>
      <div className="table-responsive">
        {paymentLogs?.loading ? (
          <Loading />
        ) : (
          <table className="table table-striped">
            <thead className="">
              <tr>
                <th>Date & Time</th>
                <th>Amount</th>
                <th>Gateway</th>
                <th>External Ref</th>
                <th>Bkash Transaction ID</th>
                <th>Payment Ref ID</th>
                <th>Status</th>
                <th>Action</th>
                <th>Approved By</th>
              </tr>
            </thead>
            {paymentLogs?.data?.payments?.length ? (
              paymentLogs?.data?.payments.map((payment, index) => (
                <tr key={index}>
                  <td>{moment(payment?.createdAt).format("lll")}</td>
                  <td>&#2547;{payment?.amount}</td>
                  <td>{payment?.gatewayName}</td>
                  <td>{payment?.externalRef}</td>
                  <td>{payment?.trxId}</td>
                  <td>{payment?.paymentRefId}</td>
                  <td>
                    <span
                      className={`radius-btn ${payment?.status?.toLowerCase()}-btn`}
                    >
                      {payment?.status}
                    </span>
                  </td>
                  <td>
                    <Popconfirm
                      title="Do you confirm, that you have received this amount of money?"
                      onConfirm={() =>
                        onPaymentStatus({
                          orderId: payment?.orderId,
                          amount: parseFloat(payment?.amount),
                          transactionId: payment?.paymentRefId,
                        })
                      }
                      okText="CONFIRM"
                      cancelText="NOT SURE"
                      disabled={
                        payment?.status === "FAILED" ||
                        payment?.status === "PAID" ||
                        parseFloat(orderDetails?.totalPaid) >=
                          parseFloat(orderDetails?.total)
                      }
                    >
                      <Button
                        size="small"
                        danger
                        disabled={
                          payment?.status === "FAILED" ||
                          payment?.status === "PAID" ||
                          parseFloat(orderDetails?.totalPaid) >=
                            parseFloat(orderDetails?.total)
                        }
                      >
                        APPROVE
                      </Button>
                    </Popconfirm>
                  </td>
                  <td>
                    {" "}
                    ...
                    {/* {payment?.user?.name} */}
                  </td>
                </tr>
              ))
            ) : (
              <Empty />
            )}
          </table>
        )}
      </div>
    </>
  );
};

export default OrderPaymentLogs;
